var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ob1-price", class: _vm.classObject }, [
    _c("p", { staticClass: "visually-hidden" }, [
      _vm._v("\n        " + _vm._s(_vm.priceAccessibility) + "\n    "),
    ]),
    _vm._v(" "),
    _c(
      "p",
      { attrs: { "aria-hidden": "true" } },
      [
        _vm.priceLabel
          ? [
              _c("span", { staticClass: "ob1-price-amount-label" }, [
                _vm._v(_vm._s(_vm.priceLabel)),
              ]),
            ]
          : [
              _vm.showPiggyBank
                ? _c("span", {
                    staticClass:
                      "icon icon-phone-fund-euro font-size-24 text-dark",
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { class: _vm.amountClassObject }, [
                _vm._v(
                  _vm._s(
                    _vm._f("centsHandler")(
                      _vm._f("replacePointByComma")(_vm.formattedPrice)
                    )
                  ) + " €"
                ),
              ]),
              _vm._v(" "),
              _vm.showByMonth
                ? _c("span", { staticClass: "ob1-price-by-month" }, [
                    _vm._v("/mois"),
                  ])
                : _vm._e(),
            ],
        _vm._v(" "),
        _vm.showPromoDuration
          ? _c("span", { class: _vm.promoDurationClassObject }, [
              _c("span", [
                _vm._v("pendant " + _vm._s(_vm.duration) + " mois puis"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "ob1-price-promo-duration-by-month" }, [
                _vm._v(
                  _vm._s(
                    _vm._f("centsHandler")(
                      _vm._f("replacePointByComma")(_vm.formattedInitialPrice)
                    )
                  ) + " €/mois"
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.priceDetails && _vm.priceDetails.length > 0
          ? _c("span", {
              class: _vm.priceDetailsClassObject,
              domProps: { innerHTML: _vm._s(_vm.priceDetails) },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }